import { BaseApiService } from "./BaseApiService";
import { PREFIX } from "utils/Const";
import { IGetAllLocationsReportRequest, IGetByIdRequest } from "model";

export const prefix = PREFIX.export;

const getUrl = (url: string) => {
  return `${prefix}/${url}`;
};

const URL_EXPORT_STOCK_RECEIVING_DOCUMENT = getUrl("stock-receiving-document");
const URL_EXPORT_LO_DOCUMENT = getUrl("loading-order-document");
const URL_EXPORT_DELIVERY_PROGRESS_DOCUMENT = getUrl(
  "loading-order-delivery-progress-document"
);
const URL_EXPORT_LOCATION_REPORT = getUrl("location-report");
const URL_EXPORT_BAY4S_REPORT = getUrl("bay4s");
const URL_EXPORT_DELIVERY_HISTORY_REPORT = getUrl(
  "delivery-barcode-history-report"
);

class ExportApiService extends BaseApiService {
  // public exportStockReceivingDocument = (request: IGetByIdRequest) =>
  //   this.downloadExcel(`${URL_EXPORT_STOCK_RECEIVING_DOCUMENT}/${request.id}`);
  // public exportLODocument = (request: IGetByIdRequest) =>
  //   this.downloadExcel(`${URL_EXPORT_LO_DOCUMENT}/${request.id}`);
  // public exportLODeliveryProgressDocument = (request: IGetByIdRequest) =>
  //   this.downloadExcel(
  //     `${URL_EXPORT_DELIVERY_PROGRESS_DOCUMENT}/${request.id}`
  //   );
  // public exportLocationReport = (request: IGetAllLocationsReportRequest) =>
  //   this.downloadExcel(URL_EXPORT_LOCATION_REPORT, { params: request });
  // public exportBay4sReport = () => this.downloadExcel(URL_EXPORT_BAY4S_REPORT);
  // public exportDeliveryHistoryReport = () =>
  //   this.downloadExcel(URL_EXPORT_DELIVERY_HISTORY_REPORT);
}

export default new ExportApiService();
